import { triggerAPI, qs } from './util';

const upiRecurringFormDetails = document.querySelector(
    '.upi-recurring-form-details'
  ),
  MID = document.querySelector('.MID'),
  MIDerror = document.querySelector('.MIDerror');

upiRecurringFormDetails.classList.add('hide');
MIDerror.classList.add('hide');

function renderToggleForm(e) {
  const currentValue = e.target.value;
  if (currentValue === 'Yes') {
    upiRecurringFormDetails.classList.remove('hide');
    MID.classList.remove('hide');
  } else if (currentValue === 'No') {
    upiRecurringFormDetails.classList.remove('hide');
    MID.classList.add('hide');
    document.forms['upi-recurring-form'].MID.value = '';
  } else {
    upiRecurringFormDetails.classList.add('hide');
  }
}

function handleFormSubmit(e) {
  const upiRecurringForm = document.forms['upi-recurring-form'];
  e.preventDefault();
  let isFormSubmit = false,
    huspotPayload = {
      fields: [
        {
          name: 'razorpay_user',
          value: `${upiRecurringForm.isExistingCustomer.value}`
        },
        {
          name: 'mid',
          value: upiRecurringForm.MID.value && `${upiRecurringForm.MID.value}`
        },
        {
          name: 'full_name',
          value: `${upiRecurringForm.name.value}`
        },
        {
          name: 'phone',
          value: `${upiRecurringForm.phone.value}`
        },
        {
          name: 'email',
          value: `${upiRecurringForm.email.value}`
        },
        {
          name: 'company',
          value: `${upiRecurringForm.company.value}`
        }
      ],
      context: {
        pageUri: `www.${window.location.hostname}/${window.location.pathname}`,
        pageName: 'Razorpay Trusted Badge'
      },
      legalConsentOptions: {
        consent: {
          // Include this object when GDPR options are enabled
          consentToProcess: true,
          text:
            'I agree to allow Razorpay to store and process my personal data.',
          communications: [
            {
              value: true,
              subscriptionTypeId: 6760497,
              text: 'I agree to receive marketing communications from Razorpay.'
            }
          ]
        }
      }
    };

  if (upiRecurringForm.isExistingCustomer.value === 'Yes') {
    if (upiRecurringForm.MID.value === '') {
      MIDerror.classList.remove('hide');
      isFormSubmit = false;
    } else {
      isFormSubmit = true;
    }
  } else if (upiRecurringForm.isExistingCustomer.value === 'No') {
    isFormSubmit = true;
  }

  if (isFormSubmit) {
    MIDerror.classList.add('hide');
    triggerAPI(
      'https://api.hsforms.com/submissions/v3/integration/submit/5558946/638da222-1d9f-4675-ac36-14a83df4b58a',
      'POST',
      response => {
        qs('.after-success').classList.add('show');
        qs('.upi-recurring-form').classList.add('hide');
      },
      huspotPayload
    );
  }
}

qs('#upi-recurring-modal #is-existing-customer').addEventListener(
  'change',
  renderToggleForm
);

qs('.upi-recurring-form').addEventListener('submit', handleFormSubmit);
